import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { WEBApi } from '../API/WEBApi';
import { Pagination } from 'react-bootstrap';
import Home_7 from '../Home/Home_7';

import styles from './Blogs.module.css'
import './pagination.css'
import Heading from '../components/Heading';

import chargerImage from "./Assets/charger.webp";
import SubHeading from '../components/SubHeading';
import ImageWithLoader from '../components/ImageWithLoader';



interface Blog {
    _id: string;
    title: string;
    author: string;
    slug: string;
    date: string;
    content: string;
    image:string;
}

const Blogs: React.FC = () => {
    const [blogs, setBlogs] = useState<Blog[]>([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        document.title = 'Blog | BreatheEV';
    }, []);

    const fetchBlogs = async (currentPage: number) => {
        try {
            setIsLoading(true)
            const res = await WEBApi.getBlogs(currentPage);
            setBlogs(res.blogs);
            setTotalPages(res.totalPages);
            setIsLoading(false)
        } catch (error) {
            console.error('Error fetching blogs:', error);
        }
    };

    useEffect(() => {
        fetchBlogs(page);
    }, [page]);


    const scrollToTop = () => {
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);
      };
    

    const renderPagination = () => {
        let items = [];
        for (let number = 1; number <= totalPages; number++) {
            items.push(
                <Pagination.Item
                    key={number}
                    active={number === page}
                    onClick={() => setPage(number)}
                >
                    {number}
                </Pagination.Item>
            );
        }
        return (
            <Pagination className="justify-content-end mt-4">
                <Pagination.Prev
                    onClick={() => setPage(page - 1)}
                    disabled={page === 1}
                />
                {items}
                <Pagination.Next
                    onClick={() => setPage(page + 1)}
                    disabled={page === totalPages}
                />
            </Pagination>
        );
    };


    function stripHtml(html: string) {
        return html.replace(/<[^>]*>?/gm, '');
    }
    function getPreviewText(html: string, maxLength = 300) {
        const text = stripHtml(html);
        return text.length > maxLength ? text.substring(0, maxLength) + '...' : text;
    }




    return (
        <main id="main">
            <div className='home-main'>

                <section className={`${styles.blogsSection} page-top-margin`}>
                    <div className={`container`} >
                        <span className={styles.subtitle}>Blogs</span>
                        <Heading topBottomMargin={14}>Insights That Matter to Property Owners</Heading>
                        {/* <p className={styles.description}>
                            Stay informed with expert perspectives, success stories, and industry trends that highlight how BreatheEV is transforming EV charging for commercial and residential properties.
                        </p> */}
                        <SubHeading topBottomMargin>
                            Stay informed with expert perspectives, success stories, and industry trends that highlight how BreatheEV is transforming EV charging for commercial and residential properties.
                        </SubHeading>

                        {isLoading ?
                            <>
                                <div className={styles.cardGrid}>
                                    {[1, 2].map((_, idx) => (
                                        <div className={styles.card} key={`placeholder-${idx}`}>
                                           
                                            <div className={styles.boxContent}>
                                                <h3 className={styles.boxTitle}>
                                                    <div className={styles['slot-loading']}>
                                                        <p className="card-text placeholder-wave">
                                                            <span className="placeholder col-12"></span>
                                                        </p>
                                                    </div>
                                                </h3>
                                                <div className={styles['slot-loading']}>
                                                    <p className="card-text placeholder-wave">
                                                        <span className="placeholder col-12"></span>
                                                    </p>
                                                </div>
                                                <div className={styles['slot-loading']}>
                                                    <p className="card-text placeholder-wave">
                                                        <span className="placeholder col-12"></span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                            </>
                            :
                            <>
                                {page === 1 && blogs.length > 0 && (
                                    <div className='mb-4'>
                                        <Link target='_blank' to={`/blogs/${blogs[0].slug}`} onClick={scrollToTop} className={styles.cardLink}>
                                            <div className={styles.card}>
                                                
                                                <div className={styles.recent}>Recent</div>
                                                <div className={`${styles.imageContainer} ${styles.first}`}>
                                                    <ImageWithLoader className={styles['img']} src={blogs[0].image} alt={blogs[0].title} />
                                                    <div className={styles.boxContent}>
                                                        <h3 className={styles.boxTitle}>{blogs[0].title}</h3>

                                                        <div className={styles['data']}>{getPreviewText(blogs[0].content, 650)}</div>
                                                    </div>
                                                </div>
                                               
                                                
                                            </div>
                                            <div className={styles.viewButton}>
                                                <button>Keep Reading</button>
                                            </div>
                                        </Link>
                                    </div>
                                )}
                                <div className={styles.cardGrid}>
                                    {(page === 1 ? blogs.slice(1) : blogs).map((blog, index) => (
                                        <Link target='_blank' to={`/blogs/${blog.slug}`} onClick={scrollToTop} key={`main-${index + 1}`} className={styles.cardLink}>
                                            <div className={styles.card}>
                                                {/* <img src={blog.image} /> */}
                                                {/* <div className={styles.date}>{new Date(blog.date).toLocaleDateString()}</div> */}
                                                <div className={styles.imageContainer}>
                                                <ImageWithLoader  className={styles['img']} src={blog.image} alt={blog.title} />
                                                <div className={styles.boxContent}>
                                                    
                                                    <h3 className={styles.boxTitle}>{blog.title}</h3>
                                                    <div className={styles['data']}>{getPreviewText(blog.content)}</div>
                                                    <div className={styles['read-more']}>Read more →</div>
                                                </div>
                                                </div>
                                            </div>
                                           
                                        </Link>
                                    ))}
                                </div>
                            </>

                        }


                        {totalPages === 1 ? <></> : renderPagination()}
                    </div>


                </section>

                <Home_7 background='#e9ecee' />

            </div>

        </main>
    );
};

export default Blogs;
